import script from "./SubTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubTitle.vue?vue&type=script&lang=ts&setup=true"

import "./SubTitle.vue?vue&type=style&index=0&id=e1076630&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1076630"]])

export default __exports__